<template>
  <div>
    <div class="actModules">
      <h3 class="actModules_title" v-text="modulesTitle"></h3>
      <div class="swiper-container sellBanner" id="banner">
        <swiper class="swiper-wrapper" :options="swiperOption">
          <swiperSlide
            class="swiper-slide"
            v-for="(bannerImg, index) in tabLists"
            :key="index"
          >
            <img :src="bannerImg.img" />
          </swiperSlide>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div
        class="actRules"
        v-if="modulesRules.length > 0"
        v-html="modulesRules"
      ></div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
	name: 'h5-salesImg',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案：',
			bgImg: '背景图片',
			modulesRules: '规则描述：',
			name: '名称',
			img: '图片',
			action: '动作',
			actionType: '动作类型', // 自定义动作类型，系统内置有 ams: ams动作， link: 跳转到外链
			buttonName: '按钮文案',
			inviteBags: '轮播图'
		}
	},
	components: {
		swiper,
		swiperSlide
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字',
			label: '标题'
		},
		modulesRules: {
			type: String,
			default: '活动规则：自定义文案',
			label: '详细说明'
		},
		bgImg: {
			type: String,
			default:
        '//www.valuecoders.com/blog/wp-content/uploads/2017/11/featurednew.jpeg'
		},
		inviteBags: {
			type: Array,
			default: function (item) {
				return [
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					},
					{
						img: {
							class: 'image',
							value:
                'https://game.gtimg.cn/images/tgclub/act/a20190404actConfigCenter/h5/actInvite_boxImg.png'
						}
					}
				];
			}
		}
	},
	data () {
		return {
			swiperOption: {
				autoplay: {
					delay: 1500
				},
				speed: 600,
				pagination: '.swiper-pagination',
				paginationClickable: true
			}
		};
	},
	mounted () {},
	computed: {
		tabLists () {
			const arr = this.inviteBags
				.filter(item => !!item.img && item.img.value !== '')
				.map(item => {
					return {
						img: item.img.value
					};
				});
			return arr;
		}
	},
	methods: {
		downBtn () {}
	}
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/common";
.actModules {
  width: 7.3rem;
  margin: 0 auto;
}
.sellBanner {
  width: 7.3rem;
  margin: 0 auto;

  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/salesAndGift/salesImg.vue